const CALLBACK_NAME = '__eventorGoogleMapsReady';

let loadPromise = null;

/**
 * Loads the Google Maps Places library.
 *
 * `loading=async` keeps the Maps bootstrap off the critical path; without it Google logs
 * "loaded directly without loading=async. This can result in suboptimal performance".
 * The promise resolves with the places library, so callers never touch window.google.
 */
export default function loadGoogleMapsPlaces(apiKey) {
  if (loadPromise) return loadPromise;

  loadPromise = new Promise((resolve, reject) => {
    const { google } = window;

    if (google && google.maps && google.maps.importLibrary) {
      google.maps.importLibrary('places').then(resolve).catch(reject);

      return;
    }

    window[CALLBACK_NAME] = () => {
      window.google.maps.importLibrary('places').then(resolve).catch(reject);
    };

    const scriptElement = document.createElement('script');

    scriptElement.async = true;
    scriptElement.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}`
      + `&libraries=places&loading=async&callback=${CALLBACK_NAME}`;
    scriptElement.addEventListener('error', reject);

    document.head.appendChild(scriptElement);
  });

  return loadPromise;
}
